module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._l((_vm.numPolygons), function(i) {
    return _c('app-select-saved-polygon', {
      key: i,
      ref: "selectPolygon",
      refInFor: true,
      on: {
        "selected": _vm.onSelectPolygon
      }
    })
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "block": "",
      "disabled": _vm.numPolygons >= 5
    },
    on: {
      "click": function($event) {
        _vm.numPolygons += 1
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("comparative.add")))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "block": "",
      "disabled": _vm.numPolygons <= 2
    },
    on: {
      "click": function($event) {
        _vm.numPolygons -= 1
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("comparative.delete")))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c23ffb7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/compare/AddPolygons.vue
// module id = 1056
// module chunks = 1